import { FILE_URL } from "@/lib/api";

/** Simple img wrapper - photos are served publicly through /api/files/{path} */
export default function AuthImage({ path, alt = "", className = "", ...rest }) {
  if (!path) {
    return (
      <div
        className={`bg-[#B79256]/10 flex items-center justify-center text-[#B79256] text-xs accent-label ${className}`}
        {...rest}
      >
        no photo
      </div>
    );
  }
  return <img src={FILE_URL(path)} alt={alt} className={className} {...rest} />;
}
